/*
 * @Description : Crypto加密解密
 * @Author      : pishengjun
 * @Date        : 2022-06-14 13:33:23
 */

import CryptoJS from "crypto-js";
const keySecret = "emh1b2ZhbjE2OA=="; //  加密私钥
export default {
  //加密
  encrypt(word) {
    const key = CryptoJS.enc.Utf8.parse(keySecret);
    const srcs = CryptoJS.enc.Utf8.parse(word);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  },
  //解密
  decrypt(word) {
    const key = CryptoJS.enc.Utf8.parse(keySecret);
    const decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }
};
